import globalStyles from '../../../../global.less'
import styles from '../index.less'
const getSty = (str: string) => styles[str]
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty('KeyPoint')} ${cla ? styles[cla] : ''}`}>
    {str}
  </span>
)
const fontBoldUnderline = (str: string) => (
  <span className={`${getSty('KeyPoint')} ${getSty('underline')}`}>{str}</span>
)
export default function ProtocolDPAID() {

  return (
    <div className={`${globalStyles['container']} ${getSty('protocol')}`}>
      <h2 className={getSty('title-h2')}>
        Perjanjian Privasi Data Xiaomi Channel
      </h2>
      <p className={getSty('explain-title')}>Ketentuan Umum</p>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>Keutuhan Perjanjian Ini</h5>
            <p className={getSty('explain')}>
              Perjanjian ini terdiri dari Ketentuan Umum ini, 
              {fonSizeBold('Pemberitahuan Privasi Xiaomi Channel')} 
              (“Pengumuman Privasi”), dan 
              {fonSizeBold('Perjanjian Pengolahan Data Xiaomi Channel')}  (“DPA”
              dan tidak untuk disamakan dengan “Perjanjian ini” sebagaimana  dimaksud dalam paragraf ini).
              Ketiganya merupakan bagian yang tidak terpisahkan dari
              Perjanjian ini.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>
              Persetujuan Anda dan Otorisasi dari Pengecer
            </h5>
            <p className={getSty('explain')}>
              Dengan menerima Perjanjian ini dalam di {fonSizeBold('Xiaomi Channel')}, Anda
              menyetujui bahwa:
            </p>
            <p className={getSty('explain')}>
              (1) Xiaomi dapat memproses data pribadi Anda sebagaimana diatur
              dalam Pengumuman Privasi;
            </p>
            <p className={getSty('explain')}>
              (2) jika ini juga merupakan penerimaan DPA yang pertama oleh anggota staf manapun dari pengecer yang menggunakan {fonSizeBold('Xiaomi Channel')} disebut “Pengecer”) dan yang berpartisipasi dalam program insentif Xiaomi untuk penjualan kepada konsumen akhir,maka Anda:
            </p>
            <p className={getSty('explain')}>
              (i) menyatakan dan menjamin bahwa Anda secara sah dan diberikan otorisasi oleh hukum atau oleh Pengecer untuk mengikat Pengecer terhadap DPA dan memberikan instruksi kepada Xiaomi atas nama Pengecer untuk memproses data pribadi sesuai dengan DPA;
            </p>
            <p className={getSty('explain')}>
              (ii) dengan ini mengikat Pengecer pada DPA; dan
            </p>
            <p className={getSty('explain')}>
              (iii) mengakui bahwa setiap instruksi kepada Xiaomi, dari Anda maupun anggota staf lain dari Pengecer yang berwenang sebagaimana dimaksud dalam poin (2)(i), untuk memproses data pribadi merupakan instruksi dari Pengecer, baik disampaikan secara lisan, tertulis, melalui tindakna (misalnya mengirimkan data pribadi ke Xiaomi melalui Xiaomi Channel), tersurat maupun tersirat – dengan catatan bahwa ketidakadaan tanggapan tidak dianggap sebagai instruksi;
            </p>
            <p className={getSty('explain')}>
              (3) penerimaan Anda terhadap Perjanjian ini memiliki kekuatan hukum yang sama dengan tanda tangan tertulis Anda secara fisik;
            </p>
            <p className={getSty('explain')}>
              (4) tidak dapat dijadikan alasan pembelaan oleh Anda atau Pengecer terhadap penerapan Perjanjian ini dengan mengklaim bahwa:
            </p>
            <p className={getSty('explain')}>
              (i) tidak membaca, memahami, dan menerima seluruh isi Perjanjian ini; atau
            </p>
            <p className={getSty('explain')}>
              (ii) tidak mendapatkan otorisasi yang sah dari Pengecer untuk mengikatnya pada DPA; dan
            </p>
            <p className={getSty('explain')}>
              (5) Anda akan mengganti kerugian dan membebaskan Xiaomi dari segala tuntutan, klaim, gugatan, permintaan, ganti rugi, kewajiban,  kerugian, penyelesaian, putusan, biaya, dan pengeluaran yang timbul dari, berkaitan dengan, atau disebabkan oleh kelalaian atau pernyataan yang keliru (baik disengaja maupun tidak) terkait otorisasi Pengecer sebagaimana diatur dalam (2)(i) di atas (termasuk jika otorisasi tersebut tidak ada atau catat).
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Keterpisahan Perjanjian Ini</h5>
            <p className={getSty('explain')}>
              Jika suatu ketentuan dalam Perjanjian ini dinyatakan tidak sah, melanggar hukum, atau tidak dapat diberlakukan terhadap salah satu atau lebih dari pihak (yaitu Xiaomi, Anda, atau Pengecer (masing-masing disebut “Pihak” dan kombinasi mereka disebut “Para Pihak”, kecuali jika dinyatakan lain dalam DPA ini),maka keabsahan dankeberlakuan , ketentuan-ketentuan lainnya tidak akan terpengaruh
            </p>
          </li>
        </ol>
      </div>
      <p className={getSty('explain-title')}>
        Pemberitahuan Privasi Xiaomi Channel
      </p>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
          {fonSizeBold('Xiaomi Channel')} menyediakan informasi kinerja penjualan, perhitungan insentif, dan layanan lainnya (termasuk bentuk penyediaan layanan lain yang mungkin tersedia di masa mendatang). Untuk mendukung fungsi ini, kami dapat mengumpulkan, memproses, dan membagikan data pribadi Anda sebagai berikut:
        </p>
        <h5 className={getSty('explain')}>Verifikasi Karyawan</h5>
        <p className={getSty('explain')}>
          {fonSizeBold('Xiaomi Channel')} hanya tersedia untuk pihak tertentu (misalnya, staf yang berwenang untuk bekerja di tempat usaha Pengecer) dan membutuhkan verifikasi identitas untuk menampilkan informasi dalam {fonSizeBold('Xiaomi Channel')} serta mendukung penggunaan Anda berdasarkan izin pengguna Anda. Untuk itu, kami ("Xiaomi") perlu mengumpulkan informasi Akun Xiaomi Anda (termasuk ID Akun Xiaomi), nama, nomor telepon, dan alamat email yang Anda berikan secara sukarela.
        </p>
        <p className={getSty('explain')}>
          {fonSizeBold('Dasar hukum')} untuk kegiatan memproses data pribadi Anda adalah persetujuan Anda.
        </p>
      </div>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
          Selain itu, kami dapat terus menggunakan data pribadi di atas dan data pribadi lainnya yang Anda berikan kepada kami untuk tujuan seperti pengelolaan toko dan pengelolaan sumber daya manusia.
        </p>
        <p className={getSty('explain')}>
          Kami pastikan bahwa penggunaan data pribadi Anda akan selalu mematuhi hukum yang berlaku, dan kami hanya akan memproses data pribadi dalam jumlah minimum yang diperlukan.
        </p>
        <p className={getSty('explain')}>
          Untuk informasi lebih lanjut tentang cara kami memproses data pribadi Anda, silakan kunjungi Kebijakan Privasi kami di 
          <a
            href='https://privacy.mi.com/all/languages'
            target='_blank'
            rel='noopener noreferrer'
          >
            https://privacy.mi.com/all/languages
          </a>
          .
        </p>
        <h5 className={getSty('explain')}>
          Perjanjian Pengolahan Data Xiaomi Channel
        </h5>
      </div>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>Tujuan</h5>
            <p className={getSty('explain')}>
              DPA ini dibuat antara Xiaomi dan Pengecer (masing-masing disebut “Pihak” dan bersama-sama “Para Pihak”), dan tidak termasuk pengguna yang sebelumnya disebut sebagai “Anda”. Xiaomi tidak secara sengaja memproses data pribadi konsumen akhir untuk kepentingannya sendiri, dan dalam hal Pengecer menginstruksikan Xiaomi untuk memproses data pribadi tersebut, pengolahan harus dilakukan sesuai dengan DPA ini, atas nama Pengecer, dan hanya untuk tujuan yang diinstruksikan oleh Pengecer. Para Pihak memahami bahwa pengolalan data pribadi berdasarjab DPA ini, pengolahan tersebut dilakukan dengan syarat yang diinstruksikan oleh Pengecer kepada Xiaomi untuk memproses data pribadi konsumen akhir.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Peran dan Kepatuhan</h5>
            <p className={getSty('explain')}>
              2.1 Para Pihak mengakui bahwa Pengecer berperan sebagai pengelola data dan Xiaomi berperan sebagai pemroses data yang memproses data pribadi tertentu atas nama Pengecer sesuai dengan undang-undang perlindungan data yang berlaku.
            </p>
            <p className={getSty('explain')}>2.2 Untuk tujuan DPA ini:</p>
            <p className={getSty('explain')}>
              “Pengelola data” adalah pihak yang menentukan tujuan dan cara memproses data pribadi.
            </p>
            <p className={getSty('explain')}>
              “Pemroses data” adalah Pihak yang memproses data pribadi atas nama pengelola data.
            </p>
            <p className={getSty('explain')}>
              2.3 Xiaomi akan memproses data pribadi atas nama Penjual sesuai dengan DPA ini dan instruksi sah dari Pengecer.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('2.4 Pengecer harus memastikan instruksinya mematuhi undang-undang perlindungan data yang berlaku. ')}
              Xiaomi akan memberi tahu Pengecer jika menyadari atau mengetahui bahwa instruksi tersebut melanggar undang-undang perlindungan data yang berlaku.
              {fonSizeBold(' Namun, kegagalan Xiaomi untuk tidak memberitahu tidak membebaskan tanggung jawab Pengecer atas hal ini.')}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.5 Pengecer harus memastikan kegiatan pengolahan data oleh Xiaomi memiliki dasar hukum yang sesuai.'
              )}
            </p>
            <p className={getSty('explain')}>
              2.6 Xiaomi akan mengambil langkah-langkah yang diperlukan sesuai dengan instruksi Pengecer untuk membantu Pengecer mematuhi kewajibannya di bawah undang-undang perlindungan data.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                ' 2.7 Pengecer secara independen akan bertanggung jawab atas klaim atau kerugian yang timbul dari ketidakpatuhannya terhadap kewajiban sebagai pengelola data dan undang-undang perlindungan data yang berlaku.'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('2.8')} Pengecer diberitahu bahwa, karena data pribadi konsumen akhir yang terkait dengan produk Xiaomi merupakan data yang berharga bagi Xiaomi sendiri, {fonSizeBold('Penjual')}
               tidak boleh membagikan data pribadi tersebut dengan pihak ketiga 
              {fonSizeBold('tanpa persetujuan tertulis dari Xiaomi.')}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Hak Subjek Data</h5>
            <p className={getSty('explain')}>
              3.1 
              {fonSizeBold(
                'Pengecer bertanggung jawab sepenuhnya untuk mematuhi kewajiban terkait permintaan subjek data untuk menjalankan hak-haknya sebagaimana diatur dalam peraturan perundang-undangan perlindungan data yang berlaku.'
              )}{' '}
              Xiaomi akan membantu Pengecer dengan langkah-langkah teknis dan organisasional yang sesuai untuk memenuhi kewajiban Pengecer dalam merespon permintaan tersebut.
            </p>
            <p className={getSty('explain')}>
              3.2 Xiaomi akan memberi tahu Pengecer tanpa penundaan yang tidak semestinya setelah menerima permintaan untuk mengakses hak subjek data, serta menyampaikan informasi relevan lainnya yang diperlukan untuk menangani permintaan tersebut.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Pelanggaran Data</h5>
            <p className={getSty('explain')}>Masing-masing Pihak:</p>
            <p className={getSty('explain')}>
              4.1 akan segera memberi tahu Pihak lainnya untuk mengambil langkah menghadapi pelanggaran keamanan terkait data pribadi yang berada di bawah tanggung jawabnya yang menyebabkan atau mungkin menyebabkan akses yang tidak disengaja, ilegal, atau lainnya, transmisi, intercept, penggunaan, kebocoran, perubahan, kombinasi, penghancuran, kehilangan, atau pengolahan data pribadi lainnya (setiap pelanggaran sebagai {fonSizeBold('“Pelanggaran Data”)')} ;
              dan
            </p>
            <p className={getSty('explain')}>
              4.2 akan bekerja sama secara wajar dengan Pihak lainnya dan mengambil langkah-langkah yang wajar untuk membantu menyelidiki, mengurangi dampak, dan membaiki Pelanggaran Data.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Keamanan</h5>
            <p className={getSty('explain')}>Masing-masing Pihak harus:</p>
            <p className={getSty('explain')}>
              5.1 menerapkan langkah-langkah teknis dan organisa yang sesuai untuk melindungi data pribadi dari penghancuran, kehilangan, atau kerusakan yang tidak disengaja atau ilegal, perubahan, kebocoran tanpa izin, akses yang tidak sah, dan semua bentuk pengolahan yang ilegal lainnya;
            </p>
            <p className={getSty('explain')}>
              5.2 mengambil semua langkah yang diperlukan untuk memastikan hanya karyawan yang memiliki kewenangan yang dapat mengakses data pribadi sesuai tugasnya berdasarkan DPA;
            </p>
            <p className={getSty('explain')}>
              5.3 memastikan setiap karyawan yang memiliki akses ke data pribadi memahami kewajibannya sesuai DPA dan semua undang-undang perlindungan data yang berlaku; dan
            </p>
            <p className={getSty('explain')}>
              5.4 memastikan keandalan setiap karyawan yang memiliki akses ke data pribadi dan memastikan personnel tersebut telah menyelesaikan pelatihan yang sesuai tentang perlindungan data pribadi dan telah memasuki ketentuan kerahasiaan terkait pengolahan data pribadi.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Ganti Rugi</h5>
            <p className={getSty('explain')}>
              6.1 Masing-masing Pihak wajib menanggung dan membebaskan Pihak lainnya dari segala tuntutan, klaim, gugatan, permintaan, ganti rugi, kewajiban,  kerugian, penyelesaian, putusan, biaya, dan pengeluaran yang timbul dari, berkaitan dengan, atau disebabkan oleh kelalaian atau pernyataan yang keliru (baik disengaja maupun tidak){fontBoldUnderline('yang timbul dari, terkait dengan, atau merupakan akibat kelalaian atau pelanggaran oleh Pihak tersebut.') }
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('6.2 Xiaomi tidak akan bertanggung jawab atas kerugian melebihi jumlah biaya kontraktual yang dibayarkan oleh Pengecer dalam Perjanjian ini.') }
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>{fontBoldUnderline('Pengakhiran')}</h5>
            <p className={getSty('explain')}>
              Tanpa mengurangi hak atau upaya hukum lainnya (baik berdasarkan DPA ini maupun berdasarkan hukum),{' '}
              {fonSizeBold('masing-masing Pihak dapat mengakhiri DPA')} ini dengan segera dengan menyampaikan pemberitahuan tertulis kepada Pihak lainnya apabila:
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.1 Pihak lainnya melakukan pelanggaran terhadap kewajiban material apa pun berdasarkan DPA ini dan tidak memperbaikinya setelah menerima pemberitahuan tertulis selama 30 (tiga puluh) hari kalender untuk melakukannya; atau'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.2 Syarat dan Ketentuan Platform Xiaomi Channel telah diakhiri secara sah oleh Para Pihak.'
              )}
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}
